import { UrlObject } from "url";

type Url = string | UrlObject;

export function buildLocalizedUrl(
  url: Url,
  country: string,
  language: string,
  skipLocalePrefix = false
): Url {
  const isExternalUrl = typeof url === "string" && url.startsWith("http");
  if (skipLocalePrefix || isExternalUrl) {
    return url;
  }

  const prefixPath = (path: string) => {
    const trimmedPath = path.startsWith("/") ? path : `/${path}`;
    return `/${country}/${language}${trimmedPath}`;
  };

  if (typeof url === "string") {
    return prefixPath(url);
  }

  return {
    ...url,
    pathname: url.pathname ? prefixPath(url.pathname) : undefined,
  };
}
